export function getVariablePayComponentValue(salaryParticulars: any[]): number {
  const component = salaryParticulars.find((item) => item?.name === 'Variable Pay');
  return component?.yearly ? Number(component.yearly) : 0;
}